import React from "react";
import classes from "./SchoolOverview.module.css";

import SchoolDiagram from "../../images/schoolDiagram.png"

const SchoolOverview = (props) => {
  return (
    <div className={classes.container}>
        <h1>مدرسم لوى</h1>
      <div dir="rtl" className={classes.info}>
        مدرسة لوى للامتياز هي مدرسة نهارية مختلطة مستقلة للتلاميذ الذين يتلقون
        تعليمهم بطرق وأساليب مختلفة.<br/> ويشجّع منهاجها الأكاديمي والاجتماعي وما قبل
        المهني على تطوير القدرات والمهارات التي تعدّ ضرورية لانخراط المتعلمين في
        الحياة العملية.
      </div>
      <img src={SchoolDiagram} className={classes.diagram}/>
    </div>
  );
};
export default SchoolOverview;
